import { createStyles } from "antd-style";

export const useFormVendorConnectStyles = createStyles(({ css }: any) => ({
  root: css``,
}));
